import { render, staticRenderFns } from "./MultimediaSent.vue?vue&type=template&id=2c75c568&"
import script from "./MultimediaSent.vue?vue&type=script&lang=js&"
export * from "./MultimediaSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MultimediaSent.vue"
export default component.exports